import { franc } from "franc";
import langs from "langs";

export function DetectLanguage(text) {

    if (!text || text.length < 10) {
        return { code: "unknown", name: "Unknown" };
    }

    let langCode = franc(text);

    // Fix common misdetections
    const fallback = {
        sco: "eng", // Scots → English
        nld: "eng",
        dan: "eng"
    };

    if (fallback[langCode]) {
        langCode = fallback[langCode];
    }

    const language = langs.where("3", langCode);

    return {
        code: langCode,
        name: language ? language.name : "Unknown"
    };
}